import { Trash2, Users } from 'lucide-react';
import { EmptyState } from '@/components/design';
import { toast } from '@/components/ui/sonner';
import { deleteParticipant } from '@/data/participants';
import type { Participant } from '@/data/types';

interface Props {
  tournamentId: string;
  participants: Participant[];
}

export function ParticipantsTable({ tournamentId, participants }: Props) {
  async function handleDelete(pid: string, name: string) {
    if (!confirm(`Удалить «${name}»?`)) return;
    try {
      await deleteParticipant(tournamentId, pid);
      toast.success('Удалён');
    } catch (err) {
      toast.error('Не получилось', { description: String((err as Error).message) });
    }
  }

  if (participants.length === 0) {
    return (
      <EmptyState
        icon={Users}
        title="Пока никого"
        body="Добавьте участников вручную или импортом."
      />
    );
  }

  return (
    <table className="tbl">
      <thead>
        <tr>
          <th style={{ width: 50, textAlign: 'center' }}>#</th>
          <th>Имя</th>
          <th>Клуб</th>
          <th style={{ width: 60 }} />
        </tr>
      </thead>
      <tbody>
        {participants.map((p, idx) => (
          <tr key={p.id}>
            <td style={{ textAlign: 'center' }} className="t-mute">{idx + 1}</td>
            <td style={{ fontWeight: 500 }}>{p.displayName}</td>
            <td className="t-mute">
              {p.players.map((pl) => pl.club).filter(Boolean).join(', ') || '—'}
            </td>
            <td>
              <button
                className="btn btn-ghost btn-icon btn-sm"
                onClick={() => handleDelete(p.id, p.displayName)}
                title="Удалить"
              >
                <Trash2 size={13} />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
